interface MarkerSvgProps {
  shape: string | null;
  color: string | null;
  size?: number;
}

export function MarkerSvg({ shape, color, size = 16 }: MarkerSvgProps) {
  const fill = color || "#868e96";

  switch (shape) {
    case "circle":
      return (
        <svg width={size} height={size} viewBox="0 0 24 24">
          <circle
            cx="12"
            cy="12"
            r="10"
            fill={fill}
            stroke="white"
            strokeWidth="2"
          />
        </svg>
      );
    case "square":
      return (
        <svg width={size} height={size} viewBox="0 0 24 24">
          <rect
            x="2"
            y="2"
            width="20"
            height="20"
            fill={fill}
            stroke="white"
            strokeWidth="2"
          />
        </svg>
      );
    case "triangle":
      return (
        <svg width={size} height={size} viewBox="0 0 24 24">
          <polygon
            points="12,2 22,22 2,22"
            fill={fill}
            stroke="white"
            strokeWidth="2"
          />
        </svg>
      );
    case "diamond":
      return (
        <svg width={size} height={size} viewBox="0 0 24 24">
          <polygon
            points="12,2 22,12 12,22 2,12"
            fill={fill}
            stroke="white"
            strokeWidth="2"
          />
        </svg>
      );
    case "star":
      return (
        <svg width={size} height={size} viewBox="0 0 24 24">
          <polygon
            points="12,2 15,9 22,9 16.5,14 18.5,22 12,17.5 5.5,22 7.5,14 2,9 9,9"
            fill={fill}
            stroke="white"
            strokeWidth="1.5"
          />
        </svg>
      );
    default:
      return (
        <svg width={size} height={size} viewBox="0 0 24 24">
          <circle
            cx="12"
            cy="12"
            r="10"
            fill={fill}
            stroke="white"
            strokeWidth="2"
          />
        </svg>
      );
  }
}
